import React from 'react';
import {
  Sidebar,
  SidebarTitle,
  InfoBlock,
  InfoLabel,
  InfoValue,
  AddressCard,
  MapWrap,
  DocList,
  DocItem,
  DocLink,
} from './styled';

const defaultAddress = ['Via Example 123', '20100 Milan (MI)', 'Italy'];

export default React.memo(function StoreInfoSidebar({
  storeName,
  slug,
  businessEmail,
  website,
  vatNumber,
  taxCode,
  address = defaultAddress,
  documents = [],
}) {
  const mapQuery = encodeURIComponent(storeName || 'Store');
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <Sidebar>
      <SidebarTitle>Store Information</SidebarTitle>
      <InfoBlock>
        <InfoLabel>Tag</InfoLabel>
        <InfoValue>@{slug || '—'}</InfoValue>
      </InfoBlock>
      <InfoBlock>
        <InfoLabel>Name</InfoLabel>
        <InfoValue>{storeName || '—'}</InfoValue>
      </InfoBlock>
      <InfoBlock>
        <InfoLabel>Email</InfoLabel>
        <InfoValue>{user.data.user.email || '—'}</InfoValue>
      </InfoBlock>
      <InfoBlock>
        <InfoLabel>Website</InfoLabel>
        <InfoValue>{website || '—'}</InfoValue>
      </InfoBlock>
      {/* <InfoBlock>
        <InfoLabel>VAT</InfoLabel>
        <InfoValue>{vatNumber || '—'}</InfoValue>
      </InfoBlock> */}


      <SidebarTitle style={{ fontSize: '0.875rem', marginTop: '2.5rem' }}>
        Address
      </SidebarTitle>
      <AddressCard>
        {Array.isArray(address) ? address.map((line, i) => <div key={i}>{line}</div>) : address || '—'}
      </AddressCard>

      <SidebarTitle style={{ fontSize: '0.875rem', marginTop: '2.5rem' }}>
        Location
      </SidebarTitle>
      <MapWrap>
        <iframe
          title="store-map"
          src={`https://www.google.com/maps?q=${mapQuery}&output=embed`}
          loading="lazy"
        />
      </MapWrap>

      <SidebarTitle style={{ fontSize: '0.875rem', marginTop: '2.5rem' }}>
        Documents
      </SidebarTitle>
      {documents && documents.length > 0 ? (
        <DocList>
          {documents.map((doc, i) => (
            <DocItem key={i}>
              <div style={{ fontSize: '0.75rem', fontWeight: 500, color: '#5ce9ff' }}>
                📄 {doc.name || doc.title || 'Document'}
              </div>
              <DocLink href={doc.url} target="_blank" rel="noreferrer">
                Download
              </DocLink>
            </DocItem>
          ))}
        </DocList>
      ) : (
        <div style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)' }}>
          No documents available.
        </div>
      )}
    </Sidebar>
  );
});
